/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./DashboardPreferencesAPI'
], function(APIFactory, DashboardPreferencesAPI) {
	class DashboardPreferences {

		constructor() {
			this._api = APIFactory.createAPI(this, [DashboardPreferencesAPI]);
			this._preferences = {};
		}

		initialize() {
			try {
				let storageValue = window.localStorage.getItem('dashboardPreferences');
				if(storageValue !== null) {
					try {
						this._preferences = JSON.parse(storageValue);
					} catch(err) {
						this._preferences = {};
					}
				}
				return Promise.resolve();
			} catch(err) {
				return Promise.reject(err);
			}
		}

		getAPI() {
			return this._api;
		}

		getPreference(name) {
			return this._preferences[name];
		}

		setPreference(name, value) {
			this._preferences[name] = value;
		}

		savePreferences() {
			let response = Promise.resolve();
			try {
				window.localStorage.setItem('dashboardPreferences', JSON.stringify(this._preferences));
			} catch(err) {
				response = Promise.reject(err);
			}
			return response;
		}
	}
	return DashboardPreferences;
});